import React from 'react';
import { connect } from 'react-redux';
import { withAlertHandler } from 'entoro-shared';
import { Field, reduxForm, reset } from 'redux-form';
import { offerCommentsQuery, submitReplyMutation } from '../../../../apollo';

import { withApollo } from 'react-apollo';
import ReplySection from './ReplySection';
import TextFieldArea from '../../../FormFields/TextField';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const Replies = reduxForm({
  form: 'replyForm',
})(
  ({
    setSnackbarMessage,
    disabled,

    handleSubmit,
    submitting,
    handleSnackbarError,
    index,
    client,
    comment,
    showReply,
    submitText,
    offer,
  }) => {
    const MySwal = withReactContent(Swal);
    const Toast = MySwal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener('mouseenter', MySwal.stopTimer);
        toast.addEventListener('mouseleave', MySwal.resumeTimer);
      },
    });

    const submiReply = async (values, dispatch) => {
      const { mutate } = client;

      const refetchQueries = [
        {
          query: offerCommentsQuery,
          variables: {
            offerId: offer._id,
          },
        },
      ];
      try {
        // const reply = {};
        const variables = {
          input: {
            _id: comment._id,
            reply: {
              text: values['text' + index],
              //...values,
            },
          },
        };
        const { data } = await mutate({
          mutation: submitReplyMutation,
          variables,
          refetchQueries,
        });

        if (data.submitReply) {
          dispatch(reset('replyForm'));
          //comment added
          Toast.fire({
            icon: 'success',
            title: 'Reply added successfully',
          });
        }
      } catch (error) {
        handleSnackbarError(error);
      }
    };
    return (
      <div>
        <ReplySection replies={comment.replies} index={index} />
        {showReply && (
          <div className='add-comment-box'>
            <div className='add-comment-form'>
              <div className='w-col w-col-12'>
                <form id='add-comment-form' onSubmit={handleSubmit(submiReply)}>
                  <h3>Leave a Reply</h3>
                  <Field
                    component={TextFieldArea}
                    name={'text' + index}
                    label='Reply Comment'
                    placeholder='Enter your reply and press Enter'
                    autoFocus
                  />
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
);

export default connect()(withApollo(withAlertHandler(Replies)));



// WEBPACK FOOTER //
// ./src/components/OfferOverview/Comments/Replies/index.js